import Vue from 'vue'

let vueInstance = new Vue()
let introBus

export default {
  getVueInstance: () => vueInstance,
  getIntroBus: () => introBus,
  setIntroBus: (bus) => {
    introBus = bus
  }
}



// WEBPACK FOOTER //
// ./src/utils/introBus.js